const resizable = {
  mounted(el: HTMLElement) {
    const dialogBody = el as HTMLElement

    let startDom = null

    const rightHandle = document.createElement('div')
    rightHandle.className = 'rightHandle'
    rightHandle.style.width = '4px'
    rightHandle.style.height = '100%'
    // rightHandle.style.background = '#000'
    rightHandle.style.position = 'absolute'
    rightHandle.style.right = '0'
    rightHandle.style.top = '0'
    rightHandle.style.cursor = 'e-resize'
    rightHandle.style.userSelect = 'none'

    const bottomHandle = document.createElement('div')
    bottomHandle.className = 'bottomHandle'
    bottomHandle.style.width = '100%'
    bottomHandle.style.height = '4px'
    // bottomHandle.style.background = '#000'
    bottomHandle.style.position = 'absolute'
    bottomHandle.style.bottom = '0'
    bottomHandle.style.left = '0'
    bottomHandle.style.cursor = 's-resize'
    bottomHandle.style.userSelect = 'none'

    const resizeHandle = document.createElement('div')
    resizeHandle.className = 'resizeHandle'
    resizeHandle.style.width = '10px'
    resizeHandle.style.height = '10px'
    // resizeHandle.style.background = '#000'
    resizeHandle.style.position = 'absolute'
    resizeHandle.style.right = '0'
    resizeHandle.style.bottom = '0'
    resizeHandle.style.cursor = 'se-resize'
    resizeHandle.style.userSelect = 'none'
    resizeHandle.style.zIndex = '4'

    if (dialogBody) {
      dialogBody.appendChild(resizeHandle)
      dialogBody.appendChild(rightHandle)
      dialogBody.appendChild(bottomHandle)
    }

    let startX: number, startY: number, startWidth: number, startHeight: number

    const mouseMoveHandler = (event: MouseEvent) => {
      event.stopPropagation()
      const deltaX = event.clientX - startX
      const deltaY = event.clientY - startY
      if (startDom !== 'bottomHandle') el.style.width = `${startWidth + deltaX}px`
      if (startDom !== 'rightHandle') el.style.height = `${startHeight + deltaY}px`
    }

    const mouseUpHandler = () => {
      document.removeEventListener('mousemove', mouseMoveHandler)
      document.removeEventListener('mouseup', mouseUpHandler)
    }

    const mouseDownHandler = (event: MouseEvent) => {
      const target = event.target as Element
      startDom = target.className
      startX = event.clientX
      startY = event.clientY
      startWidth = parseInt(document.defaultView!.getComputedStyle(el).width, 10)
      startHeight = parseInt(document.defaultView!.getComputedStyle(el).height, 10)
      document.addEventListener('mousemove', mouseMoveHandler)
      document.addEventListener('mouseup', mouseUpHandler)
    }

    resizeHandle.addEventListener('mousedown', mouseDownHandler)
    rightHandle.addEventListener('mousedown', mouseDownHandler)
    bottomHandle.addEventListener('mousedown', mouseDownHandler)
  },
}

export default resizable
